import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

export interface RedeemWristband {
  id: number;
  unique_id: string;
  ticket_id: number;
}

export interface RedeemTicketDetails {
  id: number;
  ticket_id: string;
  name: string;
  email: string;
  ticket_count: number;
  category: string;
  seat_number: string | null;
  is_redeemed: boolean;
  eligible: boolean;
  wristbands: RedeemWristband[];
  confirmed_wristband?: RedeemWristband;
}

export interface CheckRedeemRequest {
  ticketId: string;
  eventId: number;
}

export interface RedeemResponse {
  success: boolean;
  found: boolean;
  message: string;
  data: RedeemTicketDetails;
}

const postRedeemRequest = async (url: string, params: CheckRedeemRequest | (CheckRedeemRequest & { wristbandId: string })): Promise<RedeemResponse> => {
  const { data } = await axios.post<RedeemResponse>(url, params, {
    headers: { Authorization: accessToken },
  });
  return data;
};

const checkRedeemTicket = (params: CheckRedeemRequest) => postRedeemRequest(endpoints.CHECK_REDEEM, params);
const postDoubleRedeem = (params: CheckRedeemRequest & { wristbandId: string }) => postRedeemRequest(endpoints.DOUBLE_REDEEM, params);

const postRedeemTicket = async (params: any) => {
  const url = endpoints.REDEEM;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const postRedeemTicketByName = async (params: any) => {
  const url = endpoints.REDEEM + "/by-name";

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const postCheckIn = async (params: any) => {
  const url = endpoints.CHECKIN;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const postCheckOut = async (params: any) => {
  const url = endpoints.CHECKOUT;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const service = {
  checkRedeemTicket,
  postDoubleRedeem,
  postRedeemTicket,
  postCheckIn,
  postCheckOut,
  postRedeemTicketByName,
}

export default service;
